import axios from 'axios';

const maskSensitiveData = (s: string, start: number, end: number) => {
  return s && (s.slice(0, start) + "*".repeat(s.length - (start + end)) + s.slice(s.length - end, s.length));
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "x-api-key": process.env.REACT_APP_API_KEY, "content-type": "application/json" }
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error({
      message: error.message,
      headers: JSON.stringify({
        apiMaskedKey: maskSensitiveData(error.config?.headers['x-api-key'], 2, 3),
        accept: error.config?.headers?.Accept,
        contentType: error.config?.headers['Content-Type'],
        maskedBearer: maskSensitiveData(error.config?.headers?.Authorization, 9, 3)
      }),
      response: JSON.stringify(error.response?.__sentry_xhr__),
      request: JSON.stringify(error.request?.__sentry_xhr__)
    });
    return Promise.reject((error.response && error.response.data) || error.message || (typeof error === "string" && error) || 'Something went wrong')
  }
);

export default axiosInstance;
